exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".title[data-v-3d18aadc]{font-size:12px;font-weight:700;padding-top:10px;text-transform:uppercase}.option_image[data-v-3d18aadc]{width:50px;margin-right:5px}.aligned[data-v-3d18aadc]{display:flex;align-items:center}.price[data-v-3d18aadc]{font-weight:700;margin-left:5px}.message[data-v-3d18aadc]{color:red}", ""]);

// exports
